import React from 'react';

import cls from 'classnames';

import { ClassName } from '../../types';

import './Switch.scss';

export interface SwitchProps extends ClassName {
  checked: boolean;
  onChange?: (checked: boolean) => void;
}

export const Switch = ({ checked, onChange }: SwitchProps) => (
  <div className={cls('switch', 'on', { rtl: checked })} onClick={() => onChange?.(!checked)}>
    <div className="toggle" />
  </div>
);
